export const TRANSLATIONS = {
  en: {
    translation: {
      login: "Login",
      welcome_to_cryptospinhub: "Welcome to Winzee",
      username: "Username",
      password: "Password",
      forgot_password: "Forgot Password",
      still_no_account: "Still no Account ?",
      register: "Register",
      password_recovery: "Password Recovery",
      reset_password_content:
        "Enter the Mobile Number of your Winzee account and we will send you an OTP to reset your password",
      enter_email: "Enter Email",
      get_OTP: "Get OTP",
      enter_OTP: "Enter OTP",
      enter_new_password: "Enter New Password",
      submit: "Submit",
      submitting: "Submitting",

      please_enter_email: "Please Enter Email",
      please_enter_mobile_number: "Please Enter Mobile Number",
      all_fields_are_mandatory: "All filelds are mandatory",
      password_reset_success: "Password reset success",
      request_failed: "Request Failed",

      home: "Home",
      sports: "Sports",
      exchange: "Exchange",
      casino: "Casino",
      live_games: "Live-games",
      live_casino: "Live Casino",
      cricket: "Cricket",
      tennis: "Tennis",
      basketball: "Basketball",
      aviator: "Aviator",
      evolution: "Evolution",
      ezugi: "Ezugi",
      supernowa: "Supernowa",
      vivo: "Vivo",
      qtech: "Qtech",
      aura: "Aura",
      promotion_and_bonuses: "Promotions and bonuses",
      promotion: "Promotions",
      and_bonuses: "and bonuses",
      games_by_provider: "Games by provider",

      USD: "USD",
      main_wallet: "Main Wallet",
      cash: "Cash",
      bonus: "Bonus",
      deposit: "Deposit",
      profile: "Profile",
      withdrawal: "Withdrawal",
      bets_history: "Bets History",
      referral: "Referral",
      statement: "Statement",
      deposit_history: "Deposit History",
      withdraw_history: "Withdraw History",
      log_out: "Log Out",

      all: "All",

      casino_games: "Casino Games",
      instant_games: "Instant Games",
      slots: "Slots",
      popular_games: "Popular Games",
      top_games: "Top Games",

      menu: "Menu",
      responsible_gaming: "Responsible Gaming",
      terms_and_conditions: "Terms and Conditions",
      bonus_terms_and_conditions: "Bonus Terms and Conditions",
      withdrawal_policy: "Withdrawal Policy",
      fair_play: "Fair Play",
      games_rules: "Games Rules",
      privacy_and_policy: "Privacy and Policy",
      privacy_policy: "Privacy Policy",
      AML_KYC_policy: "AML/KYC Policy",
      support: "Support",
      contact_us: "Contact US",
      about_us: "About Us",
      application: "Application",
      for_android: "for Android",
      follow_us: "Follow us",
      age18_content:
        "You can play only if you are an adult. Gambling can cause pathological addiction",
      copyright: "Copyright © 2025 winzee.online, All rights reserved.",
    },
  },
  po: {
    translation: {
      login: "Conecte-se",
      welcome_to_cryptospinhub: "Bem-vindo ao Winzee",
      username: "Nome de utilizador",
      password: "Senha",
      forgot_password: "Esqueceu-se da sua senha",
      still_no_account: "Ainda sem conta?",
      register: "Cadastre-se",
      password_recovery: "Recuperação de palavra-passe",
      reset_password_content:
        "Introduza o número de telemóvel da sua conta Winzee e enviar-lhe-emos um OTP para redefinir a sua palavra-passe",
      enter_email: "Introduza o e-mail",
      get_OTP: "Obter OTP",
      enter_OTP: "Digite OTP",
      enter_new_password: "Introduza a nova senha",
      submit: "Enviar",
      submitting: "Enviando",

      please_enter_email: "Por favor insira o e-mail",
      please_enter_mobile_number: "Por favor insira o número de telemóvel",
      all_fields_are_mandatory:
        "Todos os campos são de preenchimento obrigatório",
      password_reset_success: "Sucesso na redefinição da palavra-passe",
      request_failed: "Falha na solicitação",

      home: "Lar",
      sports: "Esportes",
      exchange: "Intercâmbio",
      casino: "Cassino",
      live_games: "Jogos ao vivo",
      live_casino: "Cassino ao vivo",
      cricket: "Grilo",
      tennis: "Tênis",
      basketball: "Basquetebol",
      aviator: "Aviador",
      evolution: "Evolução",
      ezugi: "Ezugi",
      supernowa: "Supernova",
      vivo: "Vivo",
      qtech: "Qtech",
      aura: "Aura",
      promotion_and_bonuses: "Promoções e bónus",
      promotion: "Promoções",
      and_bonuses: "e bónus",
      games_by_provider: "Jogos por fornecedores",

      USD: "USD",
      main_wallet: "Carteira Principal",
      cash: "Dinheiro",
      bonus: "Bônus",
      deposit: "Depósito",
      profile: "Perfil",
      withdrawal: "Cancelamento",
      bets_history: "Histórico de apostas",
      referral: "Referência",
      statement: "Declaração",
      deposit_history: "Histórico de Depósitos",
      withdraw_history: "Histórico de retiradas",
      log_out: "Sair",

      all: "Todos",

      casino_games: "Jogos de Cassino",
      instant_games: "Jogos Instantâneos",
      slots: "Caça-níqueis",
      popular_games: "Jogos Populares",
      top_games: "Melhores jogos",

      menu: "Menu",
      responsible_gaming: "Jogo Responsável",
      terms_and_conditions: "Termos e Condições",
      bonus_terms_and_conditions: "Termos e Condições do Bônus",
      withdrawal_policy: "Política de Retirada",
      fair_play: "Jogo limpo",
      games_rules: "Regras dos Jogos",
      privacy_and_policy: "Privacidade e Política",
      privacy_policy: "política de Privacidade",
      AML_KYC_policy: "Política AML/KYC",
      support: "Apoiar",
      contact_us: "Contate-nos",
      about_us: "Sobre nós",
      application: "Aplicativo",
      for_android: "para Android",
      follow_us: "Siga-nos",
      age18_content:
        "Você só pode jogar se for adulto. O jogo pode causar dependência patológica",
      copyright:
        "Copyright © 2025 winzee.online, Todos os direitos reservados.",
    },
  },
  es: {
    translation: {
      login: "Acceso",
      welcome_to_cryptospinhub: "Bienvenido a Winzee",
      username: "Nombre de usuario",
      password: "Contraseña",
      forgot_password: "Has olvidado tu contraseña",
      still_no_account: "¿Aún no tienes cuenta?",
      register: "Registro",
      password_recovery: "Recuperación de contraseña",
      reset_password_content:
        "Ingrese el número de móvil de su cuenta Winzee y le enviaremos una OTP para restablecer su contraseña",
      enter_email: "Ingrese el correo electrónico",
      get_OTP: "Obtener OTP",
      enter_OTP: "Ingrese la OTP",
      enter_new_password: "Ingrese una nueva contraseña",
      submit: "Entregar",
      submitting: "Sumisión",

      please_enter_email: "Por favor ingrese el correo electrónico",
      please_enter_mobile_number: "Por favor ingrese el número de móvil",
      all_fields_are_mandatory: "Todos los campos son obligatorios",
      password_reset_success: "Restablecimiento de contraseña exitoso",
      request_failed: "Solicitud fallida",

      home: "Hogar",
      sports: "Deportes",
      exchange: "Intercambio",
      casino: "Casino",
      live_games: "Juegos en vivo",
      live_casino: "Casino en vivo",
      cricket: "Cricket",
      tennis: "Tenis",
      basketball: "Baloncesto",
      aviator: "Aviador",
      evolution: "Evolución",
      ezugi: "Ezugi",
      supernowa: "Supernowa",
      vivo: "Vivo",
      qtech: "Qtech",
      aura: "Aura",
      promotion_and_bonuses: "Promociones y bonificaciones",
      promotion: "Promociones",
      and_bonuses: "y bonificaciones",
      games_by_provider: "Juegos por proveedores",

      USD: "USD",
      main_wallet: "Cartera principal",
      cash: "Dinero",
      bonus: "Prima",
      deposit: "Depósito",
      profile: "Perfil",
      withdrawal: "Retiro",
      bets_history: "Historial de apuestas",
      referral: "Remisión",
      statement: "Declaración",
      deposit_history: "Historial de depósitos",
      withdraw_history: "Retirar historial",
      log_out: "Finalizar la sesión",

      all: "Toda",

      casino_games: "Juegos de Casino",
      instant_games: "Juegos instantáneos",
      slots: "Tragamonedas",
      popular_games: "Juegos populares",
      top_games: "Juegos destacados",

      menu: "Menú",
      responsible_gaming: "Juego responsable",
      terms_and_conditions: "Términos y condiciones",
      bonus_terms_and_conditions: "Términos y condiciones de bonificación",
      withdrawal_policy: "Política de retiro",
      fair_play: "Juego limpio",
      games_rules: "Reglas de los juegos",
      privacy_and_policy: "Privacidad y política",
      privacy_policy: "política de privacidad",
      AML_KYC_policy: "Política AML/KYC",
      support: "Apoyo",
      contact_us: "Contáctenos",
      about_us: "Sobre nosotras",
      application: "Solicitud",
      for_android: "para Android",
      follow_us: "Síganos",
      age18_content:
        "Solo puedes jugar si eres adulto. El juego puede causar adicción patológica",
      copyright:
        "Copyright © 2025 winzee.online, Todos los derechos reservados.",
    },
  },
};
